import script from "./ArgonViewSwitcher.vue?vue&type=script&setup=true&lang=js"
export * from "./ArgonViewSwitcher.vue?vue&type=script&setup=true&lang=js"

import "./ArgonViewSwitcher.vue?vue&type=style&index=0&id=77e706f2&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-77e706f2"]])

export default __exports__